import { connect } from 'react-redux';
// Components
import ForgotUsername from './ForgotUsername';

// Actions
import { forgotUserName } from 'store/reducers/login/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

export default connect(
  null,
  { forgotUserName, gtmUserEvent },
  null,
  {
    withRef: true
  }
)(ForgotUsername);



// WEBPACK FOOTER //
// ./src/components/pages/User/SignIn/components/ForgotUsername/ForgotUsernameContainer.js